import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export const ExpandableIndicatorListCypressAttribute: CypressAttribute = {
  buttons: {
    EXPAND_BUTTON: 'ExpandableIndicatorListCypressAttribute:buttons:EXPAND_BUTTON',
    REDUCE_BUTTON: 'ExpandableIndicatorListCypressAttribute:buttons:REDUCE_BUTTON'
  },
  inputs: {},
  views: {
    LIST_ITEM: 'ExpandableIndicatorListCypressAttribute:views:LIST_ITEM'
  }
};
